import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
/**
 * Shell nav slot — lets a SHELL inject its own chrome into the shared Layout's
 * nav row without app-core knowing about it. The `Layout` lives inside the
 * shared route table, so a shell can't pass it a prop directly; it provides the
 * slot via context instead. Desktop fills `navExtra` with the data-bridge pill
 * (a desktop-only concept); web-ui / mini-app leave it empty. Keeps
 * surface-specific chrome IN the nav row (one visual context) rather than as a
 * floating overlay (Dmitry review 2026-07-13).
 */
const NavExtraContext = createContext(null);
export function NavExtraProvider({ node, children }) {
    return _jsx(NavExtraContext.Provider, { value: node, children: children });
}
export function useNavExtra() {
    return useContext(NavExtraContext);
}
//# sourceMappingURL=navSlots.js.map